<template>
  <div class="survey-progress-bar">
    <div class="bar-values">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span class="primary-value" v-bind="attrs" v-on="on">
            {{ finishedPercentage.toFixed(1) }}% abgeschlossen
          </span>
        </template>
        {{ finishedCount }} von {{ total }} abgeschlossen
      </v-tooltip>
      |
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span class="secondary-value" v-bind="attrs" v-on="on">
            {{ startedPercentage.toFixed(1) }}% begonnen
          </span>
        </template>
        {{ startedCount }} von {{ total }} begonnen
      </v-tooltip>
      |
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span class="bg-value" v-bind="attrs" v-on="on">
            {{ notStartedPercentage.toFixed(1) }}% nicht begonnen
          </span>
        </template>
        {{ notStartedCount }} von {{ total }} nicht begonnen
      </v-tooltip>
    </div>

    <div class="bar-track">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="bar bar-bg" v-bind="attrs" v-on="on" />
        </template>
        {{ notStartedCount }} von {{ total }} nicht begonnen
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="bar bar-secondary"
            :style="{width: startedPercentage.toFixed(1) + '%'}"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        {{ startedCount }} von {{ total }} begonnen
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div
            class="bar bar-primary"
            :style="{width: finishedPercentage.toFixed(1) + '%'}"
            v-bind="attrs"
            v-on="on"
          />
        </template>
        {{ finishedCount }} von {{ total }} abgeschlossen
      </v-tooltip>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SurveyProgressBar',
  props: {
    // Total number of generated tokens (100% of the bar)
    total: {
      type: Number,
      required: true,
    },
    // Number of started surveys (includes finished ones)
    startedCount: {
      type: Number,
      required: true,
    },
    // Number of finished surveys
    finishedCount: {
      type: Number,
      required: true,
    },
  },
  computed: {
    notStartedCount() {
      return this.total - this.startedCount
    },
    startedPercentage() {
      return this.percentage(this.startedCount)
    },
    finishedPercentage() {
      return this.percentage(this.finishedCount)
    },
    notStartedPercentage() {
      return this.percentage(this.notStartedCount)
    },
  },
  methods: {
    percentage(count) {
      return this.total > 0 ? (count / this.total) * 100 : 0
    },
  },
}
</script>

<style scoped>
  .bar-values {
    display: flex;
    gap: 8px;
    margin-bottom: 5px;
    font-size: 12px;
    font-weight: bold;
  }

  .bg-value {
    color: #989898;
  }

  .primary-value {
    color: #023465;
  }

  .secondary-value {
    color: #527795;
  }

  .bar-track {
    width: 100%;
    height: 18px;
    background-color: #e9edf1;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
  }

  .bar {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 3px;
  }

  .bar-bg {
    background-color: #e9edf1;
    width: 100%;
    z-index: 1;
  }

  .bar-secondary {
    background-color: #8ba9c2;
    z-index: 2;
  }

  .bar-primary {
    background-color: #023465;
    z-index: 3;
  }
</style>
